export default __webpack_public_path__ + "static/4-1ded8f85e2166c01d695f8731a99e6c5.png";